import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbAccordionModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';

import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { LeafletModule } from '@bluehalo/ngx-leaflet';
import { MapComponent } from './core/map.component';
import { LayerStoreComponent } from './layer-store/layer-store.component';
import { MapControlsComponent } from './controls/map-controls/map-controls.component';
import { DrawStyleModalComponent } from './controls/draw-style/draw-style-modal.component';
import { ControlsIconsModule } from '../controls/icons.module';
import { LayerService } from './services/layer.service';
import { DrawStyleService } from './services/draw-style.service';
import { TransformationService } from './services/transformation.service';
import { MapStatusService } from './services/map-status.service';
import { WmsLayerInputComponent } from './controls/wms-layer-input/wms-layer-input';
import { CheckboxTreeComponent } from './project/checkbox-tree.component';
import { ProjectNewComponent } from './project/new/project-new.component';
import { AttachmentsListComponent } from './project/attachments/attachments-list.component';
import { ProjectManagerComponent } from './project/project-manager.component';
import { GridControlsComponent } from './controls/grid-controls/grid-controls.component';

import { SyncOptionsModalComponent } from './project/sync-options-modal.component';
import { GpkgLayerSelectModalComponent } from './controls/gpkg-layer-select-modal.component';

@NgModule({
  imports: [
    // Angular Core
    CommonModule,
    FormsModule,
    // Third-party
    ControlsIconsModule,
    LeafletModule,
    NgbAccordionModule,
    NgbModule,
    NgxSliderModule,
    // Standalone Components
    WmsLayerInputComponent,
    CheckboxTreeComponent,
    AttachmentsListComponent,
    ProjectManagerComponent,
    GridControlsComponent,
    MapControlsComponent,
    MapComponent,
    DrawStyleModalComponent,
    LayerStoreComponent,
    ProjectNewComponent,
    SyncOptionsModalComponent,
    GpkgLayerSelectModalComponent
  ],
  // All components are now standalone - no declarations needed
  declarations: [],
  exports: [
    LayerStoreComponent,
    MapComponent,
    GpkgLayerSelectModalComponent
  ],
  providers: [
    LayerService,
    MapStatusService,
    TransformationService,
    DrawStyleService
  ]
})
export class MapModule {}
